import { Collection } from "@type-r/models";
import { asTimelessDate, Column, Columns, Flex } from "lqx-react";
import React from "react";
import { RemittanceAdviceChange } from "../../api/remittanceAdviceChange";
import { AssetTileStatusField, AssetTileField, AssetTileHeaderField, CheckboxColumn, FirstColumn, SecondColumn, TileContainer, useAssetTileClasses, EventsColumn } from "../../components/asset-section-styles";
import { DigiCheckbox, DigiTooltip, limitText } from "../../shared";
import { InblockedAssetsEventStatus } from "../inblocked-assets-event-status";
import { RemittanceAdviceExternalSystems } from "./externalSystems";

export const RemittanceAdviceTile = ($active, selected: Collection<RemittanceAdviceChange>, selectAllAssets) => (({ data, index, style }) => {
    const remittanceAdviceChange: RemittanceAdviceChange = data.items[index];
    const classes = useAssetTileClasses({ isSelected: $active.value && $active.value.id === remittanceAdviceChange.id });
    const $checked = selected ? selected.$includes(remittanceAdviceChange) : null;
    const applyNumbersFormat = (num) => parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    const onRemittanceAdviceClicked = remittanceAdviceChange => $active.set(remittanceAdviceChange);

    return (<>
        <div key={remittanceAdviceChange.id} style={style} className={classes.root} onClick={() => onRemittanceAdviceClicked(remittanceAdviceChange)}>
            <TileContainer>
                <Columns>
                    {selectAllAssets.value &&
                        <CheckboxColumn>
                            <DigiCheckbox checked={true} disabled={true} />
                        </CheckboxColumn>
                    }
                    {$checked && !selectAllAssets.value &&
                        <CheckboxColumn>
                            <DigiCheckbox $checked={$checked} disabled={selectAllAssets.value} />
                        </CheckboxColumn>
                    }
                    <Column>
                        <Flex row>
                            <Columns>
                                <EventsColumn>
                                    <Flex row>
                                        <InblockedAssetsEventStatus assetChange={remittanceAdviceChange} externalSystems={RemittanceAdviceExternalSystems} />
                                    </Flex>
                                    <Flex row>
                                        {/* <>DummyCell</> */}
                                    </Flex>
                                </EventsColumn>
                                <FirstColumn>
                                    <Flex row>
                                        <DigiTooltip title={remittanceAdviceChange.paymentReferenceNumber}>
                                            <AssetTileStatusField> {limitText(remittanceAdviceChange.paymentReferenceNumber, 18)}</AssetTileStatusField>
                                        </DigiTooltip>
                                    </Flex>
                                    <Flex row>
                                        <AssetTileField>Payment Date {asTimelessDate(remittanceAdviceChange.paymentDate)}</AssetTileField>
                                    </Flex>
                                </FirstColumn>
                                <SecondColumn>
                                    <DigiTooltip title={`${remittanceAdviceChange.payee.company.name} - ${remittanceAdviceChange.payor.company.name}`}>
                                        <AssetTileHeaderField >{limitText(remittanceAdviceChange.payee.company.name, 60)} {remittanceAdviceChange.payee.company.name && '-'} {limitText(remittanceAdviceChange.payor.company.name, 60)}</AssetTileHeaderField>
                                    </DigiTooltip>
                                </SecondColumn>
                            </Columns>
                        </Flex>
                    </Column>
                </Columns>
            </TileContainer>
        </div >
    </>
    )
})
